import React from "react";
import {
    IconActivity24, IconApplication24, IconArchive24,
    IconNotification20,
    IconPlane24,
    ToolMenu,
    ToolMenuItem,
} from 'pac-ux-components';
import {useLocation} from "react-router-dom";
import IconCloudLogo
    from 'pac-ux-components/build/NavigationBars/CloudBar/CloudLogo';

function LeftPane({initials}) {
    const location = useLocation();

    return (<div className="left-pane" style={{
        width: 330, height: 1024, backgroundColor: '#F3F5F7', display: 'block', position: 'absolute', top: 0, left: 0
    }}>
        <ToolMenu
            handleClosed={function noRefCheck() {
            }}
            handleCloudbar={function noRefCheck() {
            }}
            isClosed={false}
            lineColor="#2a7fc9"
            style={{ width: 330, marginLeft: 0, backgroundColor: '#E9EEF2'}}
            title="UPO Settings"
        >
            <ToolMenuItem
                as="a"
                href="/"
                icon={<IconPlane24/>}
                isActive={location.pathname === '/'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0, marginTop: 20, backgroundColor: '#F3F5F7'}}
                title="Tenants"
            />
            <ToolMenuItem
                as="a"
                href="/stores"
                icon={<img src="/stores.svg" width={24} height={23} alt="Stores"/>}
                isActive={location.pathname === '/stores'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0}}
                title="Stores"
            />
            <ToolMenuItem
                as="a"
                href="/payment-providers"
                icon={<img src="/image/payment-card.svg" width={24} height={23} alt="Payment"/>}
                isActive={location.pathname === '/payment-providers'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0}}
                title="Payment"
            />
            <ToolMenuItem
                as="a"
                href="/pac-products"
                icon={<img src="/image/product.svg" width={24} height={23} alt="PAC Products"/>}
                isActive={location.pathname === '/pac-products'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0}}
                title="PAC Products"
            />
            <ToolMenuItem
                as="a"
                href="/logs"
                icon={<img src="/image/history_icon.svg" width={24} height={23} alt="Stores"/>}
                isActive={location.pathname === '/logs'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0}}
                title="History Log"
            />
            <ToolMenuItem
                as="a"
                href="/transactions"
                icon={<IconArchive24/>}
                isActive={location.pathname === '/transactions'}
                isDisabled={false}
                isExpanded
                style={{width: 330, marginLeft: 0}}
                title="Transactions"
            />
        </ToolMenu>
        <div/>
        <div style={{
            backgroundColor: '#E9EEF2',
            position: 'absolute',
            bottom: 0,
            padding: 20,
            height: 80,
            width: 330,
            display: 'flex',
            alignItems: 'center',
            color: "#2A7FC9"
        }}>
            <img src="/image/panasonic_logo.svg" height="14" width="92" alt="Panasonic Logo"/>
            <span style={{
                display: 'flex', alignItems: 'center', marginLeft: 'auto'
            }}>
                <span><IconNotification20 style={{marginRight: 10}}/></span>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    fontSize: 10,
                    color: "#2A7FC9",
                }}>
                  {initials}
                </div>
            </span>
        </div>
    </div>);
}

export default LeftPane;